import { Component, inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { combineLatest, Observable, Observer, Subject, takeUntil } from 'rxjs';
import { EventViewModel } from '../../../../models-views/event.view.model';
import { AppCommon } from '../../../../providers/app-common';
import { environment } from '../../../../../environments/environment';
import { PaymentMethodsService } from '../../../../services/payment-methods.service';
import { PaymentAccountBank, PaymentAccountCreditCard, PaymentAccountUpi } from '../../../../models/payment-method.model';

interface PaymentSourceRow {
  payment_method: 'BANK_TRANSFER' | 'CREDIT_CARD' | 'UPI';
  bank_account: number | null;
  upi_account: number | null;
  credit_card_account: number | null;
  sourceLabel: string;
}

@Component({
  selector: 'app-add-advance-payment',
  standalone: false,
  templateUrl: './add-advance-payment.component.html',
  styleUrl: './add-advance-payment.component.scss'
})
export class AddAdvancePaymentComponent {
    isEditMode: boolean = false;
    showExchangeRateWarning: boolean = false;
  loading:boolean = false
  loadMsg:string = 'Creating payment...'
  payment:any
  destroy$ = new Subject();
  loadingConversion:boolean = false
  form: FormGroup;
  loggedInUser :any
  fileList: NzUploadFile[] = []
  submisions = [ ];
  timezones = [ ];
  paymentMethods = [
            {id:'BANK_TRANSFER',name :'Bank Transfer' } ,
            {id:'CREDIT_CARD',name :'Credit Card' } ,
            // {id:'PAYMENT LINK',name :'Payment Link' } ,
            {id:'CHEQUE',name :'Cheque' } ,
            {id:'CASH',name :'Cash' } ,
            {id:'UPI',name :'UPI' } ,
            {id:'MIXED',name :'Mixed' } ,
            {id:'OTHER',name :'Other' }
              ]
  paymentStatus = [
    {id:'INITIATED',name :'Initiated' } ,
    {id:'IN-PROGRESS',name :'In Progress' } ,
    {id:'COMPLETED',name :'Completed' } ,
    {id:'PAID',name :'Paid' } ,
    {id:'UNPAID',name :'Unpaid' } ,
  ]
  users = [ ];
  invoices = [ ];
  currencyList = [ ]
  paymentType = [ ]
  paymentSourceRows: PaymentSourceRow[] = [];
  sourceModalVisible = false;
  sourceSubmitting = false;
  sourceForm: FormGroup;
  accountBanks: PaymentAccountBank[] = [];
  accountCards: PaymentAccountCreditCard[] = [];
  accountUpis: PaymentAccountUpi[] = [];
  sourceLoading = false;
  constructor(private vm: EventViewModel, private route: ActivatedRoute,
    private fb: FormBuilder, private modalRef: NzModalRef, private message: NzMessageService,
    private paymentMethodsService: PaymentMethodsService) {
   this.vm.addAdvancePaymentComponent = this
   this.loggedInUser = AppCommon.getloggedInObject().user
   this.payment = inject(NZ_MODAL_DATA);
   this.initForm()
  this.initSourceForm()

   this.form.get('type').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(
    (e) => {
      if(e == 2){
      this.form.get('invoice').addValidators(Validators.required)
      } else {
      this.form.get('invoice').setValue(null)
      this.form.get('invoice').removeValidators(Validators.required)
      this.form.get('invoice').clearValidators()
      this.form.get('invoice').updateValueAndValidity()
     }

    }
   )
   this.form.get('payment_method').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(
    (e) => {
      if(e == 'PAYMENT LINK') {
      this.form.get('payment_link').addValidators(Validators.required)
      this.form.get('payment_link').updateValueAndValidity()
      } else {
      this.form.get('payment_link').setValue(null)
      this.form.get('payment_link').removeValidators(Validators.required)
      this.form.get('payment_link').setValidators([this.urlValidator])
      this.form.get('payment_link').updateValueAndValidity()
     }

     if (!this.showPaymentSourceSection) {
      this.paymentSourceRows = [];
     } else {
      this.loadSourceAccounts();
     }

    }
   )
   this.vm.userList.pipe(takeUntil(this.destroy$)).subscribe( e => this.users = e.results );
   this.vm.vendorSubmissionResponseModel.pipe(takeUntil(this.destroy$)).subscribe( e => this.submisions = e.results );
   this.vm.currencyList.pipe(takeUntil(this.destroy$)).subscribe( e => this.currencyList = e.results );
   this.vm.timezone.pipe(takeUntil(this.destroy$)).subscribe( (d:any ) =>   this.timezones = d.results )
   this.vm.paymentType.pipe(takeUntil(this.destroy$)).subscribe( e => this.paymentType = e.results );
   this.vm.invoiceResponseModel.pipe(takeUntil(this.destroy$)).subscribe( e => this.invoices = e.results );
  const eventId = this.payment?.id ?? this.payment?.data?.event_details?.id ?? this.payment?.data?.event;
  this.vm.getVendorSubmissions(1,500,eventId, '','advancedPaymentsComponent', true)
   this.vm.getTimezoneList()
  this.vm.getInvoices(1,500,'addAdvancePaymentComponent', eventId)
   this.vm.getPaymentType()
   this.vm.getUserList(1,500);
   this.vm.getCurrencyList(1,500);
   this.getCurrencyChange()
   this.getAmountPaidUSD()
   this.getAmountPaidUSDOnExchangeRateChange()

  if(this.payment?.data){
   this.isEditMode = true;
   this.updateForm()
   this.loadExistingPaymentSources();
  }
  }



  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  initForm(){
    this.form = this.fb.group({
      type:[null],
      payment_date: [null, [Validators.required]],
      amount_paid_selected_currency: [null, [Validators.required]],
      amount_paid_usd: [{value: null, disabled: true}, [Validators.required]],
      payment_method: [null, [Validators.required]],
      transaction_id: [null],
      usd_currency_exchange_rate: [null],
      paid_currency: [null],
      notes: [null],
      status	:[null, [Validators.required]],
      due_date: [null],
      invoice: [null],
      payment_link: [null, [this.urlValidator]],
      submission: [null, [Validators.required]],
      recorded_by: [null],
      file:[[]]
    });
  }

  initSourceForm() {
    this.sourceForm = this.fb.group({
      payment_method: [null, [Validators.required]],
      bank_account: [null],
      upi_account: [null],
      credit_card_account: [null],
    });

    this.sourceForm.get('payment_method')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((method) => {
      this.applySourceValidators(method);
      this.sourceForm.patchValue({
        bank_account: null,
        upi_account: null,
        credit_card_account: null,
      }, { emitEvent: false });
    });
  }

  get selectedPaymentMethod(): string {
    return this.form.get('payment_method')?.value;
  }

  get showPaymentSourceSection(): boolean {
    return ['BANK_TRANSFER', 'CREDIT_CARD', 'UPI', 'MIXED'].includes(this.selectedPaymentMethod);
  }

  get isMixedPaymentMethod(): boolean {
    return this.selectedPaymentMethod === 'MIXED';
  }

  private applySourceValidators(method: string) {
    const bankControl = this.sourceForm.get('bank_account');
    const upiControl = this.sourceForm.get('upi_account');
    const cardControl = this.sourceForm.get('credit_card_account');

    bankControl?.clearValidators();
    upiControl?.clearValidators();
    cardControl?.clearValidators();

    if (method === 'BANK_TRANSFER') {
      bankControl?.setValidators([Validators.required]);
    }
    if (method === 'UPI') {
      upiControl?.setValidators([Validators.required]);
    }
    if (method === 'CREDIT_CARD') {
      cardControl?.setValidators([Validators.required]);
    }

    bankControl?.updateValueAndValidity({ emitEvent: false });
    upiControl?.updateValueAndValidity({ emitEvent: false });
    cardControl?.updateValueAndValidity({ emitEvent: false });
  }

  loadSourceAccounts() {
    if (this.accountBanks.length && this.accountCards.length && this.accountUpis.length) {
      return;
    }

    this.sourceLoading = true;

    combineLatest([
      this.paymentMethodsService.getBankAccounts(1, 500),
      this.paymentMethodsService.getCreditCards(1, 500),
      this.paymentMethodsService.getUpiAccounts(1, 500)
    ]).pipe(takeUntil(this.destroy$)).subscribe({
      next: ([banks, cards, upis]) => {
        this.accountBanks = banks?.results || [];
        this.accountCards = cards?.results || [];
        this.accountUpis = upis?.results || [];
        this.paymentSourceRows = this.paymentSourceRows.map((row) => {
          const sourceId = row.bank_account || row.upi_account || row.credit_card_account;
          return {
            ...row,
            sourceLabel: sourceId ? this.getAccountLabelByMethod(row.payment_method, sourceId) : row.sourceLabel,
          };
        });
        this.sourceLoading = false;
      },
      error: () => {
        this.sourceLoading = false;
      }
    });
  }

  openAddSourceModal() {
    if (!this.showPaymentSourceSection) {
      return;
    }

    this.loadSourceAccounts();
    const defaultMethod = this.isMixedPaymentMethod ? null : this.selectedPaymentMethod;
    this.sourceForm.reset({
      payment_method: defaultMethod,
      bank_account: null,
      upi_account: null,
      credit_card_account: null,
    });
    if (defaultMethod) {
      this.applySourceValidators(defaultMethod);
    }
    this.sourceModalVisible = true;
  }

  closeSourceModal() {
    this.sourceModalVisible = false;
    this.sourceSubmitting = false;
    this.sourceForm.reset();
  }

  getAccountLabelByMethod(method: string, id: number): string {
    if (method === 'BANK_TRANSFER') {
      const bank = this.accountBanks.find((el) => el.id === id);
      return bank ? `${bank.account_name} - ${bank.bank_name}` : `Bank #${id}`;
    }
    if (method === 'UPI') {
      const upi = this.accountUpis.find((el) => el.id === id);
      return upi ? `${upi.account_name} - ${upi.upi_id}` : `UPI #${id}`;
    }
    const card = this.accountCards.find((el) => el.id === id);
    return card ? `${card.account_name} - ${card.bank_name}` : `Card #${id}`;
  }

  addPaymentSourceRow() {
    this.sourceForm.markAllAsTouched();
    if (this.sourceForm.invalid) {
      return;
    }

    const value = this.sourceForm.value;
    const selectedMethod = this.isMixedPaymentMethod ? value.payment_method : this.selectedPaymentMethod;
    let bankAccount: number | null = null;
    let upiAccount: number | null = null;
    let cardAccount: number | null = null;
    let sourceId: number | null = null;

    if (selectedMethod === 'BANK_TRANSFER') {
      bankAccount = Number(value.bank_account);
      sourceId = bankAccount;
    }
    if (selectedMethod === 'UPI') {
      upiAccount = Number(value.upi_account);
      sourceId = upiAccount;
    }
    if (selectedMethod === 'CREDIT_CARD') {
      cardAccount = Number(value.credit_card_account);
      sourceId = cardAccount;
    }

    if (!sourceId) {
      return;
    }

    this.paymentSourceRows = [
      ...this.paymentSourceRows,
      {
        payment_method: selectedMethod,
        bank_account: bankAccount,
        upi_account: upiAccount,
        credit_card_account: cardAccount,
        sourceLabel: this.getAccountLabelByMethod(selectedMethod, sourceId),
      }
    ];

    this.closeSourceModal();
  }

  removePaymentSourceRow(index: number) {
    this.paymentSourceRows.splice(index, 1);
    this.paymentSourceRows = [...this.paymentSourceRows];
  }

  urlValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }

    try {
      const parsedUrl = new URL(value);
      if (parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:') {
        return null;
      }
      return { invalidUrl: true };
    } catch {
      return { invalidUrl: true };
    }
  }

  updateForm(){
    let data = {
      payment_date: this.payment.data.payment_date,
      type: this.payment.data.type,
      amount_paid_usd: this.payment.data.amount_paid_usd ,
      amount_paid_selected_currency: this.payment.data.amount_paid_selected_currency ,
      payment_method: this.payment.data.payment_method ,
      status: this.payment.data.status ,
      payment_link: this.payment.data.payment_link ,
      due_date: this.payment.data.due_date ,
      transaction_id: this.payment.data.transaction_id ,
      usd_currency_exchange_rate: this.payment.data.usd_currency_exchange_rate ,
      paid_currency: this.payment.data.paid_currency ,
      notes: this.payment.data.notes ,
      submission: this.payment.data.submission ,
      invoice: this.payment.data.invoice ,
      recorded_by: this.payment.data.recorded_by ,
      file: this.payment.data.file
    }
    this.form.patchValue(data)
    this.fileList = this.payment.data.file_details.map(file => ({
        uid: file.id,
        name: this.getFileName(file.file_url),
        status: 'done',
        url: `${environment.api_url}${file.file_url}`
      }))
  }


  private toSourceId(item: any, idKeys: string[]): number | null {
    if (typeof item === 'number') {
      return item;
    }
    if (typeof item === 'string') {
      const parsed = Number(item);
      return Number.isFinite(parsed) ? parsed : null;
    }
    if (item && typeof item.id === 'number') {
      return item.id;
    }
    if (item && typeof item.id === 'string') {
      const parsed = Number(item.id);
      return Number.isFinite(parsed) ? parsed : null;
    }
    if (!item || typeof item !== 'object') {
      return null;
    }

    for (const key of idKeys) {
      const value = item[key];
      if (typeof value === 'number') {
        return value;
      }
      if (typeof value === 'string') {
        const parsed = Number(value);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
      if (value && typeof value.id === 'number') {
        return value.id;
      }
      if (value && typeof value.id === 'string') {
        const parsed = Number(value.id);
        if (Number.isFinite(parsed)) {
          return parsed;
        }
      }
    }
    return null;
  }

  getPaymentSourceDisplay(row: PaymentSourceRow): string {
    if (row.sourceLabel) {
      return row.sourceLabel;
    }

    const sourceId = row.bank_account || row.upi_account || row.credit_card_account;
    if (!sourceId) {
      return '-';
    }

    return this.getAccountLabelByMethod(row.payment_method, sourceId);
  }

  private loadExistingPaymentSources() {
    this.loadSourceAccounts();

    const bankRows = (this.payment?.data?.payment_source_bank || [])
      .map((item: any) => this.toSourceId(item, ['bank_account', 'bank_account_id']))
      .filter((id: number | null) => !!id)
      .map((id: number) => ({
        payment_method: 'BANK_TRANSFER' as const,
        bank_account: id,
        upi_account: null,
        credit_card_account: null,
        sourceLabel: this.getAccountLabelByMethod('BANK_TRANSFER', id),
      }));

    const upiRows = (this.payment?.data?.payment_source_upi || [])
      .map((item: any) => this.toSourceId(item, ['upi_account', 'upi_account_id']))
      .filter((id: number | null) => !!id)
      .map((id: number) => ({
        payment_method: 'UPI' as const,
        bank_account: null,
        upi_account: id,
        credit_card_account: null,
        sourceLabel: this.getAccountLabelByMethod('UPI', id),
      }));

    const cardRows = (this.payment?.data?.payment_source_cc || [])
      .map((item: any) => this.toSourceId(item, ['credit_card_account', 'credit_card_account_id']))
      .filter((id: number | null) => !!id)
      .map((id: number) => ({
        payment_method: 'CREDIT_CARD' as const,
        bank_account: null,
        upi_account: null,
        credit_card_account: id,
        sourceLabel: this.getAccountLabelByMethod('CREDIT_CARD', id),
      }));

    this.paymentSourceRows = [...bankRows, ...upiRows, ...cardRows];
  }

  private toUniqueNumberArray(values: Array<number | null | undefined>): number[] {
    return [...new Set(values.filter((v): v is number => typeof v === 'number' && !Number.isNaN(v)))];
  }

   getFileName(file_url:string): string {
    return file_url.split('/').pop()?.split('?')[0] || '';
  }

  getCurrencyChange(){
    this.form.get('paid_currency').valueChanges.subscribe( (e) => {
      if(e && !this.isEditMode){
        this.loadingConversion = true;
        this.vm.getconvertedCurrency('2',e,'addAdvancePaymentComponent');
      }
    });
  }




  getAmountPaidUSDOnExchangeRateChange() {
  this.form.get('usd_currency_exchange_rate').valueChanges.pipe(
    takeUntil(this.destroy$)
  ).subscribe((exchangeRate) => {
    const amount = this.form.get('amount_paid_selected_currency').value;
    if (amount && exchangeRate) {
      const usdAmount = amount / exchangeRate; // or * if rate is inverted
      this.form.get('amount_paid_usd').setValue(usdAmount.toFixed(2), {emitEvent: false});
    }
  });
  }

  getAmountPaidUSD() {
  this.form.get('amount_paid_selected_currency').valueChanges.pipe(
    takeUntil(this.destroy$)
  ).subscribe((amount) => {
    const exchangeRate = this.form.get('usd_currency_exchange_rate').value;
    if (amount && exchangeRate) {
      const usdAmount = amount / exchangeRate; // or * if rate is inverted
      this.form.get('amount_paid_usd').setValue(usdAmount.toFixed(2), {emitEvent: false});
    }
  });
}

  fetchConvertion(e:any){
    e.preventDefault();
    if(this.isEditMode) return; // Disable API call in edit mode
    if(this.form.get('paid_currency').value){
      this.loadingConversion = true;
      this.vm.getconvertedCurrency('2',this.form.get('paid_currency').value,'addAdvancePaymentComponent');
    }
  }
  ngAfterViewInit() {
    // Show warning if paid amount changes in edit mode
    if (this.isEditMode) {
      this.form.get('amount_paid_selected_currency').valueChanges.subscribe(() => {
        this.showExchangeRateWarning = true;
      });
    }
  }

  convertedCurrencyRecieved(e:any){
    // console.log(e)
    if(e.rate){
      this.form.get('usd_currency_exchange_rate').setValue(e.rate.toFixed(2))
      this.loadingConversion = false
    }
  }

  handleModalCancel(): void {
    this.form.reset();
    this.loading = false
    this.modalRef.close(true);
  }

  onSubmit(): void {
    if (this.form.get('payment_link')?.invalid) {
      this.form.get('payment_link')?.markAsTouched();
      this.message.error('Please enter a valid payment link (include http:// or https://)');
      return;
    }

    if (this.form.valid) {
      if (this.showPaymentSourceSection && this.paymentSourceRows.length === 0) {
        this.message.error('Please add at least one payment source entry');
        return;
      }

      if (!this.isMixedPaymentMethod) {
        const invalidMethodRow = this.paymentSourceRows.some((row) => row.payment_method !== this.selectedPaymentMethod);
        if (invalidMethodRow) {
          this.message.error('Payment source method must match selected payment method');
          return;
        }
      }

      // console.log('Form submitted:', this.form.value);
      let d = this.form.getRawValue()
      d.payment_source_bank = this.toUniqueNumberArray(
        this.paymentSourceRows
          .filter((row) => row.payment_method === 'BANK_TRANSFER')
          .map((row) => row.bank_account)
      );
      d.payment_source_upi = this.toUniqueNumberArray(
        this.paymentSourceRows
          .filter((row) => row.payment_method === 'UPI')
          .map((row) => row.upi_account)
      );
      d.payment_source_cc = this.toUniqueNumberArray(
        this.paymentSourceRows
          .filter((row) => row.payment_method === 'CREDIT_CARD')
          .map((row) => row.credit_card_account)
      );

      if(this.payment?.data){
        d.id = this.payment.data.id
        d.modified_by = this.loggedInUser.id
        this.loadMsg = 'Updating payment...'
        this.loading = true
        this.vm.updateAdvancePaymentById(d)
      } else{
        this.loading = true
        d.created_by = this.loggedInUser.id;
        this.vm.createAdvancePayments(d)
      }


    } else {
      this.markAllControlsAsTouched(this.form)
      this.message.error('Please fill all required fields correctly');
      // console.warn('Form invalid');
    }
  }

 markAllControlsAsTouched(control: any) {
  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.keys(control.controls).forEach(key => {
      this.markAllControlsAsTouched(control.get(key));
    });
  } else {
    control.markAsTouched();
    control.markAsDirty();
  }
  }


  customUploadRequest = (item: any) => {
   return  this.vm.uploadMediaFile(item, this.loggedInUser.id)
  };

  onUploadChange(event: any): void {
    // console.log('Upload Event:', event);
    if (event.type === 'success') {
      this.form.get('file')?.setValue( [...this.form.get('file').value ,event.file.response.id], { emitEvent: false });
      // console.log('File uploaded successfully:', event.file);
    } else if (event.type === 'error') {
      // console.error('File upload failed:', event.file);
    } else if(event.type == 'removed'){
      this.fileList = this.fileList.filter(f => f.uid !== event.file.uid);
      this.form.get('file')?.setValue( [...this.fileList ], { emitEvent: false });
      // this.vmt.deleteMediaFile(event.file.uid)
    }


  }

   beforeUpload = (file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> =>
      new Observable((observer: Observer<boolean>) => {
          const isLt5M = file.size! / 1024 / 1024 < 5;
          if (!isLt5M) {
              this.message.error(`${file.name} is larger than 5MB!`);
              observer.next(false); // Emit false to indicate validation failed
              observer.complete();
          } else {
              observer.next(true); // Emit true to indicate validation passed
              observer.complete();
          }
      });

  downloadFile(event: MouseEvent): void {
    if (this.fileList && this.fileList.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      this.handleDownload(this.fileList[0]);
    }
  }

    handleDownload = async (file: NzUploadFile) => {
  let url = file.url;
  if (!url && file.response) {
    url = file.response.file_url || file.response.file;
    if (url && !url.startsWith('http')) {
      url = `${environment.api_url}${url}`;
    }
  }

  if (!url) return;

  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors'
    });
    const blob = await response.blob();
    const downloadUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = file.name || 'download';
    link.click();

    URL.revokeObjectURL(downloadUrl);
  } catch (err) {
    console.error('Download failed:', err);
  }
};

  formatIdToFourDigits(id: number, str: string): string {
    return id ? str + id.toString().padStart(4, '0') : '';
  }
  
}

